export const commonMenuItems = [
    {
        id: "0",
        name: "about",
        link: "/",
        mobileOnly: true,
    },
    {
        id: "1",
        name: "systems",
        link: "/rsisystemy",
    },
    {
        id: "2",
        name: "issuers",
        link: "/rsigestorzy",
    },
    {
        id: "3",
        name: "types",
        link: "",
        children: [
            {
                id: "2-3",
                name: "Osoba fizyczna",
                link: "/rsiobiekty?typ_obiektu__icontains=osoba+fizyczna",
                path: "/rsiobiekty/osoba_fizyczna",
            },
            {
                id: "2-5",
                name: "Podmiot",
                link: "/rsiobiekty?typ_obiektu__icontains=podmiot",
                path: "/rsiobiekty/podmiot",
            },
            {
                id: "2-1",
                name: "Obiekt przestrzenny",
                link: "/rsiobiekty?typ_obiektu__icontains=obiekt+przestrzenny",
                path: "/rsiobiekty/obiekt_przestrzenny",
            },
            {
                id: "2-0",
                name: "Inny",
                link: "/rsiobiekty?typ_obiektu__icontains=inny",
                path: "/rsiobiekty/inny",
            },
        ],
    },
    {
        id: "4",
        name: "features",
        link: "/rsicechy",
    },
];
